module.exports = __webpack_public_path__ + "img/coupon-bg-not-login.de9ee2c.png";